module.exports = __webpack_public_path__ + "static/media/bmihospital.19d30d78.png";